/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { FunctionComponent } from "react";

import { StrapiTerminusSidebarAd } from "@/types/strapi";

import { ButtonVariantKeys } from "@/tokens/configs/button_config";
import { Spacing } from "@/tokens/spacing";

import { Button } from "@/ui/atoms/button";
import { Picture } from "@/ui/atoms/picture";
import { Text } from "@/ui/atoms/text";
import { RichText } from "@/ui/molecules/rich_text";

import { TrackEvent } from "@/util/tokens/track_event_util";

interface TerminusSidebarAdProps {
    ad: StrapiTerminusSidebarAd;
}

export const TerminusSidebarAd: FunctionComponent<TerminusSidebarAdProps> = (
    props,
) => {
    const { ad } = props;

    /**
     * Styles
     */

    const adHeadingStyles = css({
        marginBottom: Spacing["spacing-1"],
        marginTop: Spacing["spacing-4"],
    });

    const adButtonStyles = css({
        justifyContent: "center",
        marginBottom: Spacing["spacing-2"],
        marginTop: Spacing["spacing-8"],
    });

    const adSecondaryTextStyles = css({
        textAlign: "center",
    });
    return (
        <>
            <Picture {...ad.Media.Media} alternativeText={ad.Headline} />

            <Text
                className={adHeadingStyles}
                fontSize="TerminusSidebarAdHeadline"
                tag="h4"
            >
                {ad.Headline}
            </Text>

            <Text color="lighten-80" fontSize="TerminusSidebarAdSubheadline">
                {ad.Subheadline}
            </Text>

            <Button
                className={adButtonStyles}
                fontSize="TerminusSidebarAdSubheadline"
                href={ad.Primary_CTA?.URL}
                track={TrackEvent.TERMINUS_ADS_DOWNLOAD}
                variant={
                    ad.Primary_CTA?.Appearance.toLowerCase() as ButtonVariantKeys
                }
            >
                {ad.Primary_CTA?.Text}
            </Button>

            {ad.Primary_CTA?.Secondary_Text && (
                <RichText
                    className={adSecondaryTextStyles}
                    config="TerminusSidebarAdSecondaryText"
                >
                    {ad.Primary_CTA?.Secondary_Text}
                </RichText>
            )}
        </>
    );
};
